import React, { useContext, useState } from 'react';
import { View, Text } from 'react-native'
import moment from 'moment';
import styled from 'styled-components/native';

import AuthContext from 'app/src/contexts/AuthContext';
import {
  downloadReport,
  DownloadButton
} from 'app/src/elements/ReportDownload'
import SearchableSelect from 'app/src/elements/SearchableSelect';
import { sellerOptions } from './filterOptions';

import { cardStyles as styles } from './index';
import DateInput from 'app/src/elements/DateInput';

const LotPrefixOption = styled(View)`
  flex-direction: row;
  margin-right: 10px;
  gap: 4px;
`;

const TitlesReceivedReport = ({ data }) => {
  const { lotPrefixes } = useContext(AuthContext);

  const [sellerId, setSellerId] = useState();
  const [selectedLotPrefixes, setSelectedLotPrefixes] = useState([]);

  const [startOn, setStartOn] = useState(
    moment().subtract({ months: 1 }).startOf('month').format('YYYY-MM-DD')
  );

  const [endOn, setEndOn] = useState(
    moment().subtract({ months: 1 }).endOf('month').format('YYYY-MM-DD')
  );

  const handleDownload = downloadProps => {
    downloadReport({
      ...downloadProps,
      path: 'assets-sold-by-seller-report',
      params: {
        'seller-id': sellerId,
        'start-on': startOn,
        'end-on': endOn,
        'lot-prefixes': selectedLotPrefixes,
      }
    })
  };

  const toggleSelectedLotPrefix = prefix => {
    if (selectedLotPrefixes.includes(prefix)) {
      setSelectedLotPrefixes(
        selectedLotPrefixes.filter(entry => entry !== prefix)
      );
    } else {
      setSelectedLotPrefixes([...selectedLotPrefixes, prefix]);
    }
  };

  return (
    <View style={styles.container}>
      <Text style={styles.title}>Assets Sold By Seller Report</Text>
      <Text style={styles.label}>Seller (optional):</Text>
      <SearchableSelect
        placeholder="Select Seller"
        options={sellerOptions(data)}
        value={sellerId}
        onChange={setSellerId}
      />
      <Text style={styles.label}>Start On:</Text>
      <DateInput
        style={styles.select}
        onChange={e => setStartOn(e.target.value)}
        value={startOn || ''}
      />
      <Text style={styles.label}>End On:</Text>
      <DateInput
        style={styles.select}
        onChange={e => setEndOn(e.target.value)}
        value={endOn || ''}
      />
      <Text style={styles.label}>
        Lot Prefixes (includes all if none selected):
      </Text>
      <View style={{ flexDirection: 'row', flexWrap: 'wrap' }}>
        {lotPrefixes?.map(lotPrefix => (
          <LotPrefixOption key={lotPrefix.code}>
            <input
              type="checkbox"
              checked={selectedLotPrefixes.includes(lotPrefix.code)}
              onChange={() => toggleSelectedLotPrefix(lotPrefix.code)}
            />
            <Text>{lotPrefix.code}</Text>
          </LotPrefixOption>
        ))}
      </View>
      <DownloadButton handleDownload={handleDownload} />
    </View>
  )
}

export default TitlesReceivedReport;
